import clsx from 'clsx'
import React, { FC } from 'react'
import { Link } from 'react-router-dom'
import { useLayout } from '../../../core/LayoutProvider'
import { usePageData } from '../../../core/PageData'

const DefaultTitle: FC = () => {
  const { pageTitle, pageDescription, pageBreadcrumbs, pageBack } = usePageData()
  const { config, attributes, classes } = useLayout()
  return (
    <div
      {...attributes.pageTitle}
      className={clsx('page-title d-flex', classes.pageTitle.join(' '))}
    >
      {/* begin::Title */}
      {pageTitle && (
        <h1 className='d-flex align-items-center fw-bolder my-1' style={{
          fontSize: '1.5rem',
          color: '#5E6397',
          flexBasis: '100%'
        }}>
          {pageBack && (
            <Link to={pageBack}
            ><i style={{ cursor: 'pointer' }} className="fs-1 fas fa-arrow-alt-circle-left azul-agriholmes me-3"></i></Link>
          )}
          {pageTitle}
          {pageDescription && config.pageTitle && config.pageTitle.description && (
            <>
              <span className='h-20px border-gray-200 border-start ms-3 mx-2'></span>
              <small className='text-muted fs-7 fw-bold my-1 ms-1'>{pageDescription}</small>
            </>
          )}
        </h1>
      )}
      {/* end::Title */}
    </div>
  )
}

export { DefaultTitle }
